import { render, staticRenderFns } from "./ValidatedImpactsRepresentation.vue?vue&type=template&id=536e19f4&scoped=true"
import script from "./ValidatedImpactsRepresentation.vue?vue&type=script&lang=js"
export * from "./ValidatedImpactsRepresentation.vue?vue&type=script&lang=js"
import style0 from "./ValidatedImpactsRepresentation.vue?vue&type=style&index=0&id=536e19f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e19f4",
  null
  
)

export default component.exports